export default __webpack_public_path__ + "static/media/icon-warning-check.b6566fda.svg";